import * as React from 'react';
import type {RichEditorProps} from 'src/components/lib/markdown-editor/genesis';
import RichEditor from 'src/components/lib/markdown-editor/genesis';
import Warning from 'src/components/conversation-builder/lib/warning/warning';
import classes from './rich-editor-with-warning.module.css';


const RichEditorWithWarning = ({
  warningMessage = '',
  ...rest
}: {
  warningMessage?: string;
} & RichEditorProps) => {
  return (
    <div className={classes.container}>
      <RichEditor {...rest} />
      {warningMessage && <Warning message={warningMessage} />}
    </div>
  );
};

export default RichEditorWithWarning;
